<template>
  <v-dialog persistent v-model="dialog" max-width="800px">
    <v-btn
      fixed
      fab
      bottom
      right
      color="primary"
      slot="activator"
    >
      <v-icon>add</v-icon>
    </v-btn>
    <v-card>
      <v-card-title class="primary">
        <span class="headline white--text">Geschäftsführer erstellen</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  label="Unternehmenstitel"
                  v-model="ceo.company"
                  required
                  :rules="[rules.required]"
                  :disabled="loading"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-select
                  :items="genders"
                  v-model="ceo.gender"
                  label="Anrede"
                  single-line
                  :disabled="loading"
                ></v-select>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  label="Titel"
                  v-model="ceo.title"
                  :disabled="loading"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  label="Vorname"
                  v-model="ceo.forename"
                  :disabled="loading"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  label="Nachname"
                  v-model="ceo.surname"
                  :disabled="loading"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  label="Email"
                  required
                  v-model="ceo.email"
                  :rules="[rules.required, rules.email]"
                  :disabled="loading"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-switch
                  :label="`Per ${ceo.formal ? 'Sie' : 'Du'}`"
                  v-model="ceo.formal"
                  :disabled="loading"
                ></v-switch>
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
        <small>*Pflichtfelder</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click.native="cancel()">Abbrechen</v-btn>
        <v-btn color="primary" @click.native="save()">Erstellen</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex';

  export default {
    name: 'DlgCeoNew',
    data() {
      return {
        dialog: false,
        ceo: {},
        loading: false,
        valid: true,
        genders: [
          {
            text: 'Weiblich',
            value: 'female',
          },
          {
            text: 'Männlich',
            value: 'male',
          },
        ],
      };
    },
    computed: {
      ...mapGetters({
        rules: 'common/rules/all',
      }),
    },
    methods: {
      ...mapActions({
        createCeo: 'admin/ceos/create',
        readCeos: 'admin/ceos/read',
        readAdvisors: 'admin/advisors/read',
      }),
      save() {
        if (this.$refs.form.validate()) {
          this.loading = true;
          this.createCeo(this.ceo).then((success) => {
            this.loading = false;
            if (success) {
              this.ceo = {};
              this.readCeos();
              this.dialog = false;
              this.valid = true;
            }
          });
        }
      },
      cancel() {
        this.dialog = false;
        this.ceo = {};
      },
    },
  };
</script>

<style scoped>

</style>
